import React from "react";
import { TextField, RaisedButton } from "material-ui";
import chunk from "lodash/chunk";
import pickBy from "lodash/pickBy";

import { formatPrice } from "../util";
import config from "../config";
import api from "../utils/api";

import UserTable from "./partials/user-table.jsx";
import InfoNotice from "./partials/info-notice.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import DateTimeField from "./partials/datetime-field.jsx";
import SelectField from "./partials/select-field.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";
import AuditLogTable from "./partials/audit-log-table.jsx";

const PAGESIZE = 10;

class AuditLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventBucket: null,
      objectId: "",
      action: null,
      startDate: null,
      endDate: null,
      pageData: [],
      actionList: [],
      eventBucketList: [],
      pageNum: 0,
      isLoading: false
    };

    this.fetchPage = this.fetchPage.bind(this);
  }

  static getStores() {
    return [EventBucketStore, UserStore];
  }

  static getPropsFromStores() {
    let state = UserStore.getState();
    return state;
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      section: {
        marginTop: 20
      }
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
    this.fetchAuditLogActions();
  }

  componentWillReceiveProps(newProps) {
    let eventBuckets = EventBucketStore.getEventBuckets();
    if (eventBuckets && eventBuckets.length) {
      let availableEventBuckets = eventBuckets.map(eb => {
        return {
          label: eb.mode !== "archived" ? eb.name : `${eb.name} (Archived)`,
          value: eb.id,
          mode: eb.mode
        }
      });
      availableEventBuckets.sort(function(a, b) {
        return a.label.localeCompare(b.label);
      });
      availableEventBuckets.sort(function(a, b) {
        if (a.mode === "archived") {
          return 1;
        } else {
          return -1;
        }
      });
      this.setState({ eventBucketList: availableEventBuckets });
    }
  }

  fetchAuditLogActions() {
    api.request(
      {
        method: "GET",
        endpoint: `/audit_log/actions`,
        api_key: UserStore.getState().apiKey
      },
      function (err, response) {
        if (err) {
          console.log(err);
          alert(err);
        }
        this.setState({ actionList: response.data });
      }.bind(this)
    );
  }

  fetchPage() {
    this.setState({ isLoading: true });
    api.request(
      {
        method: "GET",
        endpoint: `audit_log/page`,
        qs: {
          eventBucket: this.state.eventBucket || null,
          objectId: this.state.objectId || null,
          action: this.state.action || null,
          pageSize: PAGESIZE,
          pageNum: this.state.pageNum,
          startDate: this.state.startDate ? this.state.startDate.format('YYYY-MM-DDT00:00:00') : null,
          endDate: this.state.endDate ? this.state.endDate.format('YYYY-MM-DDT23:59:59') : null
        },
        api_key: UserStore.getState().apiKey
      },
      function (err, response) {
        if (err) {
          console.log(err);
          alert(err);
          this.setState({ isLoading: false });
        }
        else {
          let pageData = response.data.map((r, i) => {
            return {
              key: i,
              event_bucket: r.event_bucket,
              object_id: r.object,
              user: r.user.name,
              action: r.action,
              created_at: r.created_at,
              user_account: r.user_account && r.user_account.name ? r.user_account.name : "Unknown / External API Call",
              user_account_details: r.user_account_details ? r.user_account_details : null,
              //person: r.person[0] || "Not available",
              changes: r.changes
            };
          });

          let pageCount = Math.ceil(response.totalRecords / PAGESIZE);
          this.setState({ pageData: pageData, pageCount: pageCount, isLoading: false });
        }
      }.bind(this)
    );
  }

  render() {
    let styles = this.getStyles();

    let {
      loadingUsers,
    } = this.props;

    return (
      <div>
        {this.props.children /* modal */}
        <h1>
          Audit Log
        </h1>
        <div style={styles.section}>
          <InfoNotice style={{ marginTop: 20 }}>
            Filter audit log entries by an Object Id (event, film, etc), Action, or Date Range
          </InfoNotice>
          <div style={{ paddingBottom: 1 }}>
            <div style={{ display: "inline-block" }}>
              <TextField
                floatingLabelText="Object Id"
                floatingLabelFixed={true}
                value={this.state.objectId}
                onChange={(e) => { this.setState({ objectId: e.target.value }) }}
                style={{ display: "inline-block", marginRight: 24 }}
              />
            </div>
            <div style={{ width: 250, height: 30, display: "inline-block", marginRight: 24, marginTop: 10 }}>
              <SelectField
                placeholder="Select action..."
                value={this.state.action}
                options={this.state.actionList.map(i => {
                  return { value: i, label: i };
                })}
                clearable={true}
                onChange={(e) => {
                  if (e && e.value) {
                    this.setState({ "action": e.value });
                  }
                  else {
                    this.setState({ "action": null });
                  }
                }}
              />
            </div>
            <div style={{ width: 250, height: 30, display: "inline-block", marginRight: 24, marginTop: 10 }}>
              <SelectField
                placeholder="Select event bucket..."
                value={this.state.eventBucket}
                options={this.state.eventBucketList}
                clearable={true}
                onChange={(e) => {
                  if (e && e.value) {
                    this.setState({ "eventBucket": e.value });
                  }
                  else {
                    this.setState({ "eventBucket": null });
                  }
                }}
              />
            </div>
            <div style={{ display: "inline-block" }}>
              <DateTimeField
                value={this.state.startDate}
                label="Start date"
                useMoment={true}
                unclearable={true}
                hideTime={true}
                onChange={(e, v) => { this.setState({ startDate: v }) }}
                style={{ display: "inline-block", marginRight: 24 }}
              />
              <DateTimeField
                value={this.state.endDate}
                label="End Date"
                useMoment={true}
                unclearable={true}
                hideTime={true}
                onChange={(e, v) => { this.setState({ endDate: v }) }}
                style={{ display: "inline-block", marginRight: 24 }}
              />
            </div>
            <div style={{ display: "inline-block", height: 30 }}>
              <RaisedButton
                primary={true}
                onTouchTap={() => { this.fetchPage(); }}
                label="Search"
                style={{ display: "inline-block", marginRight: 10 }}
              />
              <RaisedButton
                onTouchTap={() => {
                  this.setState({
                    objectId: "",
                    action: null,
                    startDate: null,
                    endDate: null,
                    pageNum: 0
                  }, function() {
                    this.fetchPage();
                  });
                }}
                label="Clear"
                style={{ display: "inline-block" }}
              />
            </div>
          </div>
        </div>
        <div style={styles.section}>
          <AuditLogTable
            logRecords={this.state.pageData}
            pageSize={PAGESIZE}
            pages={this.state.pageCount || 1}
            loading={this.state.isLoading ? "Loading..." : null}
            onFetchData={(page, sorted, searchTerm) => {
             this.setState({
                pageNum: page
                //sorted,
                //searchTerm
              }, function() {
                this.fetchPage();
              });
            }}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(AuditLog);



// WEBPACK FOOTER //
// ./src/app/components/audit-log.jsx